export const normalizeMember = (item) => ({
    id: item.id,
    bio_category: item.bioCategory ?? item.bio_category,
    name: item.name,
    credentials: item.credentials ?? '',
    title: item.title,
    biography: item.biography,
    profile_image_url: item.profileImageUrl ?? item.profile_image_url ?? null,
    sort_order: item.sortOrder ?? item.sort_order ?? 0,
    is_active: !!(item.isActive ?? item.is_active),
});
export const normalizeCategory = (item) => ({
    id: item.id,
    bio_page: item.bioPage ?? item.bio_page,
    name: item.name,
    sort_order: item.sortOrder ?? item.sort_order ?? 0,
    is_active: !!(item.isActive ?? item.is_active),
    members: (item.members || []).map(normalizeMember),
});
export const normalizeBioPage = (data) => ({
    id: data.id,
    intro_content: data.introContent ?? data.intro_content ?? '',
    categories: (data.categories || []).map(normalizeCategory),
});
